import { combineReducers } from 'redux';

import AbTestingReducer from './abTesting/reducer';
import AuthReducer from './auth/reducer';
import DeepLinkReducer from './deepLink/reducer';
import ExercisesReducer from './exercises/reducer';
import FeaturesReducer from './features/reducer';
import GuidesReducer from './guides/reducer';
import LoadingReducer from './loading/reducer';
import ModalsReducer from './modals/reducer';
import NutritionReducer from './nutrition/reducer';
import PaymentReducer from './payment/reducer';
import SubscriptionsReducer from './subscriptions/reducer';
import UiReducer from './uiEffects/reducer';
import UserReducer from './user/reducer';
import WorkoutsReducer from './workouts/reducer';

const rootReducer = combineReducers({
    auth: AuthReducer,
    user: UserReducer,
    subscriptions: SubscriptionsReducer,
    guides: GuidesReducer,
    ui: UiReducer,
    loading: LoadingReducer,
    deepLink: DeepLinkReducer,
    exercises: ExercisesReducer,
    features: FeaturesReducer,
    workouts: WorkoutsReducer,
    modals: ModalsReducer,
    abTesting: AbTestingReducer,
    payment: PaymentReducer,
    nutrition: NutritionReducer,
});

export type RootReducer = ReturnType<typeof rootReducer>;
export default rootReducer;
